import React, { Component, useEffect } from "react";
import ReactTable from "react-table";
import { Container, Row, Col, Alert } from "reactstrap";
import "../../_Content/css/eco-template.css";
import TooltipDescricaoErro from "../Common/TooltipDescricaoErro";

class TabelaICMS extends Component {
  constructor(props) {

    super(props);
    this.state = {
      step: 1,
      resultadoData: [],
      mensagemErro: 'erro',
      colunas: [
        {
          Header: "UF-ST",
          className: "text-center txt",
          accessor: "uf",
        },
        {
          Header: "Pendentes",
          className: "text-center txt",
          accessor: "guiasPendentes",
        },
        {
          Header: "Emitidas",
          className: "text-center txt",
          accessor: "guiasEmitidas",
        },
        {
          Header: "Rejeitadas",
          className: "text-center txt",
          accessor: "guiasRejeitadas",
        }
      ],
    }
  }

  redirect = () =>{
    if (this.props.idUsuario) window.open(`https://gnre.econeteditora.com.br/validar-login/${this.props.idUsuario}/true`, "_blank");
    else window.open("https://www.econeteditora.com.br/novo/", "_blank");
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.setDataICMS != this.state.originalData) {
      this.setState({ 
        resultadoData: nextProps.setDataICMS,
        step: nextProps.step,
        mensagemErro: nextProps.mensagemErro,
    })
    }
  }

  formatarData = (props) => {
    const dia = props.split('T')[0].split('-')[2];
    const mes = props.split('T')[0].split('-')[1];
    const ano = props.split('T')[0].split('-')[0];
  
    const dataFormatada = `${dia}/${mes}/${ano}`;
    return dataFormatada;
  };

  voltarPrimeiraTela = () => {
    this.setState({
      step: 1,
    })
  }

    continuarComErroUfs = () => {
        this.setState({
            step: 3,
        })

        this.props.buscarICMS();
    }

  render() {
    return (
      <div>
            {
                this.state.step == -1 ?
                    <Container>
                        <div>
                            <div className='boxICMS'>
                                <i class='ecoico ecoico-check-new'></i>
                                <p>Ainda não recebemos retorno da Sefaz, mas suas guias estão na fila para processamento.</p>
                                <p>
                                    Verifique o resultado no EcoGNRe clicando <a href={this.redirect}>aqui</a> e consulte a aba de Pendentes para ver se é necessário fornecer algum detalhamento.
                                </p>
                                <p>
                                    Se precisar de ajuda, você pode abrir um chamado de suporte <a href="https://www.econeteditora.com.br/solucoes/index.php?acao=envio&form[destino]=10&form[area]=34&form[tipo]=6&form[assunto]=413" target="_blank">neste link</a>.
                                </p>
                                <div className='buttonsICMS'>
                                    <button className='btnIrParaDFe' onClick={this.voltarPrimeiraTela}>
                                        Voltar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Container>
                    : null
            }
        {
          this.state.step == 0 ?
          <div className='boxDFe'>
            Aguarde...
            <div 
              className="progress-bar progress-bar-striped progress-bar-animated"
              style={{ backgroundColor: '#1c5393', minWidth: '150px', maxHeight: '15px', borderRadius: '5px' }}
            >&nbsp;</div>
          </div>
          : null
        }
        {
          this.state.step == 1 ?
          <Container>
            <div>
              <div className='boxICMS'>
                <i class='ecoico ecoico-alerta-new'></i>
                <p><b>Antes de começarmos</b></p>
                <div className="blueSign">
                  {/* <img src={require('/img/ecoicos/ecoico-alerta-new.svg')} width="50"></img> */}
                  As informações validadas não serão salvas nesta solução, mas sim na solução do EcoGNRE.
                </div>
                <p>
                  É importante lembrar que este sistema coleta e armazena as informações fornecidas por você. Certifique-se de que:
                </p>
                <ul>
                  <li>
                    As informações que você fornece são precisas e completas.
                  </li>
                  <li>
                    Você está ciente das políticas de privacidade do sistema.
                  </li>
                  <li>
                    Você é responsável por manter a confidencialidade de suas credenciais de acesso.
                  </li>
                </ul>
                <p>
                  Ao confirmar sua concordância com essas responsabilidades, podemos prosseguir. Clique em 'Continuar' para iniciar a experiência.
                </p>
                <div className='buttonsICMS'>
                  {/* <button 
                    className='btnIrParaDFe'
                    onClick={this.redirect}
                  >
                    Ir para EcoDFe
                  </button> */}
                  <button 
                    className='btnCruzarDados'
                    onClick={this.props.validarICMS}
                  >
                    Continuar
                    <i className='icon-arrow-right'></i>
                  </button>
                </div>
              </div>
            </div>
          </Container>
          : null
        }
        {
          this.state.step == 2 && this.props.ufsComProblemas == undefined ?
          <Container>
            <div>
              <div className='boxICMS'>
                <i class='ecoico ecoico-danger-new'></i>
                <p><b>Ops, parece que algo deu errado...</b></p>
                <p>
                  Não foi possível executar a função devido a divergências nos 
                  Registros no arquivo EFD utilizados para a extração dos dados. Motivo:
                </p>
                <p>
                  <i>{this.props.mensagemErro}</i>
                </p>
                <p>
                  Para solucionar o problema, recomendamos verificar o arquivo EFD e 
                  corrigir os erros apontados pelo EcoAuditor.
                </p>
                <p>
                  Para mais informações, entre em contato com nosso <a href="https://www.econeteditora.com.br/solucoes/index.php?acao=envio&form[destino]=10&form[area]=34&form[tipo]=6&form[assunto]=413" target="_blank">suporte técnico</a>.
                </p>
                <div className='buttonsICMS'>
                  <button 
                    className='btnIrParaDFe'
                    onClick={this.voltarPrimeiraTela}
                  >
                    Voltar
                  </button>
                </div>
              </div>
            </div>
          </Container>
          : this.state.step == 2 && this.props.ufsComProblemas != undefined ?
        <Container>
            <div>
            <div className='boxICMS'>
                <i class='ecoico ecoico-danger-new'></i>
                <p><b>Ops, parece que algo deu errado...</b></p>
                <p>
                Não foi possível executar a função devido a divergências nos 
                Registros no arquivo EFD utilizados para a extração dos dados. Motivo:
                </p>
                <p>
                <i>
                    Para gerar a guia GNRE de forma automática para todos os estados encontados no arquivo informado, não pode conter erros nos registros: 
                    Registro 0000 - Informações Gerais; Registro 0005 - Endereço; Registro 0015 - Inscrição Estadual de substituto ou inscrição auxiliar em outras UFs; 
                    Registro E200 - Período de apuração e UF ST; Registro E210 - Valor a recolher ICMS-ST; Registro E300 - Período e UF-ST para DIFAL e FCP; 
                    Registro E310 - Valores à recolher DIFAL e FCP. 
                </i>
                <br/>
                Favor corrigir os mesmos para o(s) estado(s): {this.props.ufsComProblemas}, antes de prosseguir.
                <br/>
                <b>Atenção!!!</b> Para prosseguir sem a emissão da guia GNRE para os estados citados acima, é só clicar em continuar.
                </p>
                <p>
                Para mais informações, entre em contato com nosso <a href="https://www.econeteditora.com.br/solucoes/index.php?acao=envio&form[destino]=10&form[area]=34&form[tipo]=6&form[assunto]=413" target="_blank">suporte técnico</a>.
                </p>
                <div className='buttonsICMS'>
                <button className='btnIrParaDFe' onClick={this.voltarPrimeiraTela} >
                    Voltar
                </button>

                <button className='btnCruzarDados' onClick={this.continuarComErroUfs} >
                    Continuar
                    <i className='icon-arrow-right'></i>
                </button>
                </div>
            </div>
            </div>
        </Container>
        : null
        }
        {
          this.state.step == 3 ?
          <Container>
            <div>
              <div className='boxICMS'>
                <i class='ecoico ecoico-check-new'></i>
                <p><b>Validado com sucesso!</b></p>
                <p>
                  Seu arquivo foi validado e está pronto para iniciar o processo de apuração do ICMS.
                </p>
                {
                    this.props.flagMostrarDivPorDemora == true ?
                        <Alert color="warning">
                            <p>
                                Atenção: As guias estão no <a className="linkGNRE" onClick={this.redirect}>EcoGNRE</a>, basta acessar e processar.
                            </p>
                        </Alert>
                        :
                        <p>
                            Apurando...
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                style={{ backgroundColor: '#1c5393', minWidth: '150px', maxHeight: '15px', borderRadius: '5px' }}
                            >&nbsp;</div>
                        </p>
                }
              </div>
            </div>
          </Container>
          : null
        }
        {
          this.state.step == 4 ?
          <Container>
            <div>
              <div className='boxTabelaICMS'>
                <p className="flexGNRE">
                  Para visualizar os detalhes de cada guia e realizar as ações necessárias
                  <button 
                    className='btnCruzarDados spaceLeft'
                    onClick={this.redirect}
                  >
                    Ir para o EcoGNRE
                  </button>
                </p>
                <div className="blueSign">
                  {/* <img src={require('/img/ecoicos/ecoico-alerta-new.svg')} width="50"></img> */}
                  As informações validadas não serão salvas nesta solução, mas sim na solução do EcoGNRE.
                </div>
                <ReactTable 
                  data={this.state.resultadoData} 
                  columns={this.state.colunas} 
                  className="eco-react-table"
                  showPagination={false} pageSize={this.state.resultadoData.length} 
                />
              </div>
            </div>
          </Container>
          : null
        }
      </div>
    )
  }
}

export default TabelaICMS;


// WEBPACK FOOTER //
// ./src/Componente/Resultado/TabelaICMS.jsx